import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './HeroSection';
import '../styles/Home.css';

const Home: React.FC = () => {
  return (
    <div className="main-content">
      <meta name="google-site-verification" content="-3OTkhrHOCPlRzytSpxkqC08r3O4M8aOpN0h9XbZSnA" />
      <Helmet>
        <title>燒石鼎 | 首頁</title>
        <meta name="description" content="歡迎來到燒石鼎，汐止的職人の石頭火鍋。我們提供最新改良的食材，讓您享受美味的火鍋體驗。" />
      </Helmet>
      <h1>燒石鼎 | 汐止的職人の石頭火鍋</h1>
      <HeroSection />
    </div>
  );
}

export default Home;
